 <template>
  <v-snackbar
    :timeout="timeout"
    v-model="shown"
    :color="color"
    :multi-line="multiline"
    top
    right
  >
    {{ text }}
    <div v-if="multiline" class="text-caption">
      <ul v-if="subtextArray">
        <li v-for="(s,i) in subtext" :key="`${i}`">
          {{s}}
        </li>
      </ul>
      <template v-else>
      {{ subtext }}
      </template>
      </div>

    <template #action="{ attrs }">
      <v-btn data-testid="fermer" text v-bind="attrs" @click="hide"> Fermer </v-btn>
    </template>
  </v-snackbar>
</template>

<script>
export default {
  methods: {
    hide() {
      this.$store.commit("snackbar/hide");
    },
  },

  computed: {
    timeout() {
      return this.$store.getters["snackbar/timeout"];
    },
    shown: {
      get() {
        return this.$store.getters["snackbar/shown"];
      },
      set(shown) {
        this.$store.commit("snackbar/shown", shown);
      },
    },
    text() {
      return this.$store.getters["snackbar/text"];
    },
    subtextArray() {
      return Array.isArray(this.subtext);
    },
    subtext() {
      return this.$store.getters["snackbar/subtext"];
    },
    multiline() {
      return !!this.subtext;
    },
    color() {
      return this.$store.getters["snackbar/color"];
    },
  },
};
</script>
